import React from "react";
import SiteNavigation from "../SiteNavigation";
import MobileMenu from "../MobileMenu";
import * as styles from "./styles.module.scss";
import { useStaticQuery, graphql } from "gatsby";
import { keyBy } from "lodash-es";

export default function SiteHeader({ location }) {
  const data = useStaticQuery(graphql`
    query SiteHeader {
      allContentfulGlobal(filter: { key: { eq: "Header" } }) {
        nodes {
          slices {
            ... on ContentfulLink {
              key
              label
              url
            }
            ... on ContentfulSingleLineText {
              key
              value
            }
            ... on ContentfulGroup {
              key
              slices {
                ... on ContentfulLink {
                  label
                  url
                }
              }
            }
          }
        }
      }
    }
  `);
  const { DesktopLinks, MobileLinks, CTA, ShopNow, BuyNow, login, joinNow } =
    keyBy(data.allContentfulGlobal.nodes[0].slices, "key");

  return (
    <>
      <MobileMenu links={MobileLinks.slices} logIn={login} />

      <div className={styles.bg} />
      <SiteNavigation
        location={location}
        links={DesktopLinks.slices}
        cta={CTA}
        shopNow={ShopNow}
        buyNow={BuyNow.value}
        joinNow={joinNow}
        logIn={login}
      />
    </>
  );
}
